export default {
  benefits: {
    earn_points: 'Sammeln Sie Punkte mit jeder Bestellung',
    get_deals: 'Erhalten Sie exklusive Rabatte',
    redeem_points: 'Tauschen Sie Punkte gegen kostenloses Essen ein',
  },
};
